import { fields } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.SYSTEM_NOTIFICATION_NAME]: "",
  [fields.SYSTEM_NOTIFICATION_RECIPIENT]: "",
  [fields.SYSTEM_NOTIFICATION_TRIGGER]: [],
  [fields.SYSTEM_NOTIFICATION_ACTION]: [],
  [fields.SYSTEM_NOTIFICATION_STATUS]: [],
});
